import * as React from "react";
import {authorize,Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, Types, OnlineClaim} from "@falcon/services";
import * as moment from "moment";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";


interface IState {
    claimsLoaded: boolean,
    claims?: OnlineClaim[],
    direction: string,
    active: boolean,
}

@authorize
export class ClaimsTable extends React.Component<{}, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: {}) {
        super(props);

        this.state = {
            claimsLoaded: false,
            claims:[],
            direction: 'asc',
            active: false,
        };
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);

        this.customerPortalService.getOnlineClaims().subscribe((claims: OnlineClaim[]) => {
            this.setState({
                claims,
                claimsLoaded: true
            });
        });
    }

    public render() {
        if (this.state.claimsLoaded) {
            return (
                <React.Fragment>
                    <div className="section">
                        <div className="section-heading">Your claims</div>

                        <div className="mt-3">
                            <table className="two-column-table-header">
                                {this.renderTableHeader()}
                            </table>
                            <div className="table-scroll mt-2">
                                <table className="two-column-table-data">
                                    {this.renderTableData()}
                                </table>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderTableHeader() {
        return (
            <tr>
                <th>
                    <span className="muli-semi-bold-16">Date</span>
                    <span onClick={this.sortByDate} className={`${this.state.active &&
                    (this.state.direction === "asc" ? "fas fa-sort-up" : "fas fa-sort-down")}
                            ${!this.state.active && "fas fa-sort"} table-sort-arrow`}/>
                </th>
                <th className="muli-semi-bold-16">Status</th>
            </tr>
        )
    }

    private renderTableData(): JSX.Element[] {
        return (
            this.state.claims!.map((claim: OnlineClaim, index: number) => (
                <tr key={index}>
                    <td className="muli-semi-bold-16">
                        <span className="font-weight-light fs-14">{PluginTemplates.convertDate(claim.lossDate, "DD MMMM YYYY")}</span>
                        <br/>
                        <div className="">
                            <span className="font-weight-regular">Claim no {claim.reference}</span>
                        </div>
                    </td>
                    <td className="font-weight-semi-bold">
                        <span className={claim.status.toLowerCase() === "open" ? "accent-text" : ""}>{claim.status}</span>
                    </td>
                </tr>
            ))
        )
    }

    private sortByDate = (): void => {
        this.state.direction === 'asc' ?
            this.state.claims!.sort((a, b) => moment(a.lossDate).diff(b.lossDate))
            :
            this.state.claims!.sort((a, b) => moment(b.lossDate).diff(a.lossDate));
        this.setState({
            direction: this.state.direction === 'asc' ? 'desc' : 'asc',
            active: true
        });
    };


}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/rentersClaims/ClaimsTable.tsx